import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use(async (c) => {
  const t = await window.Clerk?.session?.getToken();
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  return typeof d === "string" ? d : d.message || JSON.stringify(d);
};

export function useFetch(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    if (!path) return;
    try {
      const r = await api.get(path);
      setData(r.data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  }, [path]);
  useEffect(() => { reload(); }, [reload]);
  return { data, loading, reload, setData };
}

export async function act(fn, ok) {
  try {
    const r = await fn();
    if (ok) toast.success(ok);
    return r?.data ?? true;
  } catch (e) {
    toast.error(errMsg(e));
    return null;
  }
}

export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-AU", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
export const pct = (v) => (v === null || v === undefined ? "—" : `${Math.round(v * 100)}%`);
export const usd = (v) => (v === null || v === undefined ? "—" : `$${Number(v).toFixed(v < 1 ? 4 : 2)}`);
